import { FRACTIONAL_ENABLED } from "./featureFlags";

/** Canada soft-launch marketing copy — no fractional/invest surfacing when disabled. */
export const LOGIN_HERO_PILL = FRACTIONAL_ENABLED
  ? "Premium fractional rentals"
  : "Premium peer-to-peer rentals";

export const FOOTER_TAGLINE = FRACTIONAL_ENABLED
  ? "Premium fractional car sharing"
  : "Premium peer-to-peer car sharing";

export const FOOTER_NEWSLETTER_HINT = FRACTIONAL_ENABLED
  ? "Phase 2 fractional ownership updates."
  : "New cities, fleet drops, and platform updates.";
